import { createContext } from 'react';
import { noop, never } from '../utils';

interface DatePickerContextValue {
  isDateSelected: (date: Date) => boolean;
  isDateHovered: (date: Date) => boolean;
  isFirstOrLastSelectedDate: (date: Date) => boolean;
  isDateBlocked: (date: Date) => boolean;
  isDateFocused: (date: Date) => boolean;
  focusedDate: Date | null;
  onDateHover: (date: Date | null) => void;
  onDateSelect: (date: Date) => void;
  onDateFocus: (date: Date) => void;
  isStartDate: (date: Date) => boolean;
  isEndDate: (date: Date) => boolean;
}

export const datePickerContextDefaultValue: DatePickerContextValue = {
  focusedDate: null,
  isDateFocused: never,
  isDateSelected: never,
  isDateHovered: never,
  isDateBlocked: never,
  isFirstOrLastSelectedDate: never,
  onDateFocus: noop,
  onDateHover: noop,
  onDateSelect: noop,
  isStartDate: never,
  isEndDate: never,
};

export const DatePickerContext = createContext(datePickerContextDefaultValue);
